/**
 * Module for segment metrics tracking events.
 * @module Metrics
 */
import { AnalyticsState } from "./analytics-state";
import { Cohort } from "./cohort";
import { GASv3 } from "./gasv3";
import { Tracking } from "./tracking";

export enum MetricKey {
    TIME_TO_LOAD = "timeToLoad",
    TIME_TO_SEGMENT_LOAD = "timeToSegmentLoad",
    TIME_TO_AVAILABLE = "timeToAvailable",
    TIME_TO_READY = "timeToReady",
    TIME_TO_START_LOAD_XID = "timeToStartLoadXID",
    TIME_TO_START_GET_XID = "timeToStartGetXID",
    TIME_TO_LOAD_XID = "timeToLoadXID"
}

type MetricData = {
    [key in MetricKey]?: number;
};

export class Metrics {
    private static metricsData: MetricData = {};
    public static loadTimestamp?: number;

    /**
     * Store the value of a single performance metric
     * @function logMetrics
     * @param {MetricKey} metricKey - the metric to log
     * @param {number} mockDate - a mock timestamp
     */
    public static logMetric(metricKey: MetricKey, mockDate?: number) {
        Metrics.metricsData[metricKey] = mockDate || Date.now();
    }

    public static setLoadTimestamp(loadTimestamp: number) {
        Metrics.loadTimestamp = loadTimestamp;
    }

    /**
     * Logs an performance metrics track call to segment via the HTTP API
     * @function sendMetrics
     * @param {object} mockReq used in testing so we don't actually send anything to Segment
     */
    public static sendMetrics(mockReq?: {
        hostFake?: string | null;
        pathFake?: string | null;
    }) {
        const loadTimestamp = Metrics.loadTimestamp;
        if (!loadTimestamp) {
            return;
        }

        // calculate all of the times
        Object.entries(Metrics.metricsData).forEach(([key, value]) => {
            if (value > 0) {
                // Todo .. should this be > loadTimestamp ??
                Metrics.metricsData[key as MetricKey] = value - loadTimestamp;
            }
        });

        const cohort = Cohort.readAtlCohort();
        const properties = {
            event: "metrics",
            eventComponent: "atlGlobal",
            metrics: Metrics.metricsData,
            atlJSVersion: AnalyticsState.version,
            cohort: cohort ? cohort.bucketAll.index : null,
            host: mockReq ? mockReq.hostFake : window.location.host,
            path: mockReq ? mockReq.pathFake : window.location.pathname,
            pageViewId: Tracking.getPageViewId() // used to tie to other events
        };

        GASv3.sendUIEvent("", properties, true);
        Metrics.resetMetrics();
    }

    // testing only
    public static resetMetrics() {
        Metrics.metricsData = {};
    }
}
